var map = {
	"./assets/base/iconfont/iconfont.css": "2284",
	"./assets/base/iconfont/iconfont.eot": "7cc1",
	"./assets/base/iconfont/iconfont.svg": "5ba2",
	"./assets/base/iconfont/iconfont.ttf": "3844",
	"./assets/base/iconfont/iconfont.woff": "1843",
	"./assets/base/img/404.jpg": "ec50",
	"./assets/base/img/back.jpg": "95cc",
	"./assets/base/img/bg/0.jpg": "1ab2",
	"./assets/base/img/bg/1.jpg": "b635",
	"./assets/base/img/bg/2.jpg": "8383",
	"./assets/base/img/bg/3.jpg": "282a",
	"./assets/base/img/bg/4.jpg": "50e2",
	"./assets/base/img/bg/5.jpg": "3851",
	"./assets/base/img/bg/6.jpg": "7005",
	"./assets/base/img/bg/7.jpg": "3872",
	"./assets/base/img/bg/8.jpg": "953a",
	"./assets/base/img/bg/9.jpg": "d4ad",
	"./assets/base/img/logo.png": "e07f",
	"./assets/base/img/logo20201123.png": "70d6",
	"./assets/base/style/app.scss": "e879",
	"./assets/base/style/login/hanweb.css": "0fe4",
	"./assets/base/style/login/hanweb20201201.css": "39d1",
	"./assets/base/style/login/sy_culture.css": "d431",
	"./assets/base/style/login/sy_culture20201201.css": "8500",
	"./assets/base/style/main.scss": "4188",
	"./assets/img/HMTOrg.png": "0438",
	"./assets/img/HMTOrgBg.png": "d179",
	"./assets/img/culturalCenterOrg.png": "1ed6",
	"./assets/img/culturalCenterOrgBg.png": "178c",
	"./assets/img/dibiao.png": "7b70",
	"./assets/img/dzjg.png": "08fe",
	"./assets/img/foreignTourismOrg.png": "2dbe",
	"./assets/img/foreignTourismOrgBg.png": "0bd3",
	"./assets/img/guideTitle.png": "7293",
	"./assets/img/login_main_bg.png": "146a",
	"./assets/img/login_main_bg1.jpeg": "757f",
	"./assets/img/logo-20180504.png": "1df5",
	"./assets/img/logo-201805041.png": "502f",
	"./assets/img/noticeTitle.png": "7cf5",
	"./assets/img/orgTitle.png": "9e9b",
	"./assets/img/small_bg1.png": "63e7",
	"./assets/img/small_bg2.png": "0cdf",
	"./assets/img/small_bg20201125.png": "e9ef",
	"./assets/img/small_bg202011252.png": "0d9c",
	"./assets/img/small_bg20805.png": "8251",
	"./assets/img/small_bg3.png": "9cef",
	"./assets/img/small_bg320201216.png": "1d1e",
	"./assets/img/sosuo_box.jpg": "11c4",
	"./assets/img/sosuo_s.jpg": "4d41",
	"./assets/img/title.png": "eb3b",
	"./assets/img/titleBg.png": "bf61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";